import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const DocumentsSection = ({ formData, handleNestedChange }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Documents</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>Passport Number</Label>
          <Input 
            value={formData.documents.passport_number} 
            onChange={(e) => handleNestedChange('documents', 'passport_number', e.target.value)} 
            data-testid="passport-number-input"
          />
        </div>
        <div>
          <Label>Passport Expiry</Label>
          <Input 
            type="date" 
            value={formData.documents.passport_expiry} 
            onChange={(e) => handleNestedChange('documents', 'passport_expiry', e.target.value)} 
            data-testid="passport-expiry-input"
          />
        </div>
        <div>
          <Label>Visa Number</Label>
          <Input 
            value={formData.documents.visa_number} 
            onChange={(e) => handleNestedChange('documents', 'visa_number', e.target.value)} 
            data-testid="visa-number-input"
          />
        </div>
        <div>
          <Label>Visa Expiry</Label>
          <Input 
            type="date" 
            value={formData.documents.visa_expiry} 
            onChange={(e) => handleNestedChange('documents', 'visa_expiry', e.target.value)} 
            data-testid="visa-expiry-input"
          />
        </div>
        <div>
          <Label>Emirates ID</Label>
          <Input 
            value={formData.documents.emirates_id} 
            onChange={(e) => handleNestedChange('documents', 'emirates_id', e.target.value)} 
            data-testid="emirates-id-input"
          />
        </div>
        <div>
          <Label>Emirates ID Expiry</Label>
          <Input 
            type="date" 
            value={formData.documents.emirates_id_expiry} 
            onChange={(e) => handleNestedChange('documents', 'emirates_id_expiry', e.target.value)} 
            data-testid="emirates-id-expiry-input"
          />
        </div>
        <div>
          <Label>Labour Number</Label>
          <Input 
            value={formData.documents.labour_number || ''} 
            onChange={(e) => handleNestedChange('documents', 'labour_number', e.target.value)} 
            data-testid="labour-number-input"
          />
        </div>
        <div>
          <Label>Labour Expiry</Label>
          <Input 
            type="date" 
            value={formData.documents.labour_expiry || ''} 
            onChange={(e) => handleNestedChange('documents', 'labour_expiry', e.target.value)} 
            data-testid="labour-expiry-input"
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentsSection;
